import * as RadixPopover from '@radix-ui/react-popover';
import { memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const comboboxInputTrigger = tailwindVariants({
  base: 'flex w-full flex-wrap items-center justify-start gap-2 rounded-4 ads:bg-base bg-gray-1 px-2 ads:text-primary text-16 text-gray-12 outline-none ads:ring-input ring-1 ring-gray-5 ring-inset focus:ads:ring-focus focus:ring-2 focus:ring-blue-9',
  defaultVariants: {
    size: 'medium',
  },
  variants: {
    size: {
      'extra-large': 'min-h-[48px] py-3 md:text-16',
      large: 'min-h-[40px] py-2 md:text-14',
      medium: 'min-h-[32px] py-1 md:text-14',
      small: 'min-h-[24px] py-1 md:text-12',
    },
  },
});

export type ComboboxInputTriggerVariants = VariantProps<typeof comboboxInputTrigger>;

export type ComboboxInputTriggerProps = RadixPopover.PopoverTriggerProps & ComboboxInputTriggerVariants;

export const ComboboxInputTrigger = memo(({ className, size, ...restOfProps }: ComboboxInputTriggerProps) => {
  return (
    <RadixPopover.Trigger
      className={comboboxInputTrigger({ className, size })}
      data-testid="COMBOBOX_INPUT_TRIGGER"
      {...restOfProps}
    />
  );
});

ComboboxInputTrigger.displayName = 'ComboboxInputTrigger';
